import React from "react";
import { Headline } from "../../components/Headline";
import { SectionContainer } from "../../components/SectionContainer";
import { Image } from "../../components/Image";

import * as styles from "./component.module.less";

function TrustLogo(props) {
    const {
        anker,
        background,
        tagline,
        semanticOfHeadline,
        headline,
        logo,
    } = props.data

    return (
        <SectionContainer sectionId={anker} containerClass={styles.container} background={background}>
            <header>
                <span className={styles.tagline}>{tagline}</span>
                <Headline semanticOfHeadline={semanticOfHeadline}>{headline}</Headline>
            </header>

            <div className={styles.logos}>
                {logo.map((logo, i) => {
                    return (
                        <Image
                            key={i}
                            image={logo}
                            imageClass={styles.image}
                        />
                    );
                })}
            </div>
        </SectionContainer>
    );
}

export { TrustLogo }